export default __webpack_public_path__ + "static/media/edit_icon.8286fa36.svg";